exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-0d6d7bd5]{font-size:15px;margin-top:10px;padding:15px;border:1px solid #eee;line-height:32px}.item .content[data-v-0d6d7bd5]{padding-top:15px;border-top:1px dashed #eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0d6d7bd5","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/patPna/addOrEdit.vue
// module id = vw0q
// module chunks = 0